import React, { FC } from 'react';

import Svg from './Svg';
import colors from '../../utils/colorConstants';

interface Props {
  width: string;
  height: string;
  fill?: string;
  className?: string;
}

const Facebook: FC<Props> = ({ className, height, width, fill = colors.lapel }) => {
  return (
    <Svg
      className={className}
      height={height}
      title="Facebook logo"
      viewBox="0 0 115 220"
      width={width}
    >
      <path
        d="M74.4 219.3v-99.8h33.5l5.02-38.9H74.41V55.79c0-11.26 3.13-18.94 19.27-18.94h20.6V2.03C110.72 1.58 98.49.52 84.27.52c-29.7 0-50.03 18.13-50.03 51.42V80.6H.66v38.9h33.58v99.8h40.17z"
        fill={fill}
      />
    </Svg>
  );
};

export default React.memo(Facebook);
